import { EEmployeeRole, EmployeeProperties } from "./employee.type";
import { ListingProperties } from "./listing.type";
import { OfficeProperties } from "./office.type";
import { UserProperties } from "./user.type";

export enum ETransferEmployeeType {
	SCHEDULED = "SCHEDULED",
	IMMEDIATELY = "IMMEDIATELY",
}

export enum ETransferEmployeeStatus {
	WAITING = "WAITING",
	TRANSFERED = "TRANSFERED",
	CANCELED = "CANCELED",
}

export interface TransferListingDataItem {
	listingId: string;
	newOfficeId: string;
	newUserId: string;
	newEmployeeId: string;
	listingData?: ListingProperties;
	newUserData?: {
		name: string;
		profilePic?: string;
		officeName?: string;
	};
}

export interface TransferEmployeeMetadata {
	userData: {
		name: string;
		profilePic?: string;
		existingRole?: EEmployeeRole[];
	};
	keepListingData: ListingProperties[];

	closingSellCount?: number;
	closingRentCount?: number;
	totalCommission?: number;
}

export interface TransferEmployeeProperties {
	transferEmployeeId: string;
	userId: string;
	originOfficeId: string;
	originEmployeeId: string;
	toOfficeId: string;
	toEmployeeId?: string;
	newRole: EEmployeeRole[];
	type: ETransferEmployeeType;
	scheduledAt?: Date;
	transferListingData?: TransferListingDataItem[];
	status: ETransferEmployeeStatus;
	metadata: TransferEmployeeMetadata;
	createdByUserId?: string;
	createdByUserMeta?: any;
	updatedAt: Date;
	createdAt: Date;

	user?: UserProperties;
	originOffice?: OfficeProperties;
	originEmployee?: EmployeeProperties;
	toOffice?: OfficeProperties;
}

export interface ListTransferEmployeeQuery {
	filterUserId?: string;
	filterOriginOfficeId?: string;
	filterOriginEmployeeId?: string;
	filterToOfficeId?: string;
	filterToEmployeeId?: string;
	filterStatus?: string;
	includeData?: string;
	sort?: string;
}
